import type { RouteRecordRaw } from 'vue-router'

// SSG 路由配置 - 只包含對外頁面
const routes: RouteRecordRaw[] = [
  // 1. 根路徑英文路由（靜態英文網站）
  {
    path: '/',
    name: 'HomeRoot',
    component: () => import('../pages/Home.vue'),
    meta: { locale: 'en', seoKey: 'home' }
  },
  {
    path: '/superpowers',
    name: 'SuperPowersRoot',
    component: () => import('../pages/SuperPowers.vue'),
    meta: { locale: 'en', seoKey: 'superpowers' }
  },
  {
    path: '/signin',
    name: 'SignInRoot',
    component: () => import('../pages/SignIn.vue'),
    meta: { locale: 'en', noindex: true }
  },
  {
    path: '/signup', 
    name: 'SignUpRoot',
    component: () => import('../pages/SignUp.vue'),
    meta: { locale: 'en', noindex: true }
  },
  {
    path: '/about',
    name: 'AboutRoot',
    component: () => import('../pages/About.vue'),
    meta: { locale: 'en', seoKey: 'about' }
  },
  {
    path: '/comparison',
    name: 'ComparisonRoot',
    component: () => import('../pages/Comparison.vue'),
    meta: { locale: 'en', seoKey: 'comparison' }
  },
  {
    path: '/pricing',
    name: 'PricingRoot', 
    component: () => import('../pages/Pricing.vue'),
    meta: { locale: 'en', seoKey: 'pricing' }
  },
  {
    path: '/contact',
    name: 'ContactRoot',
    component: () => import('../pages/Contact.vue'),
    meta: { locale: 'en', seoKey: 'contact' }
  },
  {
    path: '/privacy',
    name: 'PrivacyRoot',
    component: () => import('../pages/Privacy.vue'),
    meta: { locale: 'en', seoKey: 'privacy' }
  },
  {
    path: '/terms',
    name: 'TermsRoot',
    component: () => import('../pages/Terms.vue'),
    meta: { locale: 'en', seoKey: 'terms' }
  },
  {
    path: '/commerce',
    name: 'CommerceRoot',
    component: () => import('../pages/Commerce.vue'),
    meta: { locale: 'en', seoKey: 'commerce' }
  },
  {
    path: '/reset-password',
    name: 'ResetPasswordRoot',
    component: () => import('../pages/ResetPassword.vue'),
    meta: { locale: 'en', noindex: true }
  },
  {
    path: '/public-form/:versionId',
    name: 'PublicWorkflowFormWithId',
    component: () => import('../pages/PublicWorkflowForm.vue'),
    meta: { locale: 'en', requiresAuth: false, noindex: true }
  },
  {
    path: '/public-form',
    name: 'PublicWorkflowFormIndex',
    component: () => import('../pages/PublicWorkflowForm.vue'),
    meta: { locale: 'en', requiresAuth: false, noindex: true }
  },
  

  // 2. 多語言路由（包括 /en）
  {
    path: '/:lang(en|zh-tw|zh-cn|ja)',
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('../pages/Home.vue'),
        meta: { seoKey: 'home' }
      },
      {
        path: 'superpowers',
        name: 'SuperPowers',
        component: () => import('../pages/SuperPowers.vue'),
        meta: { seoKey: 'superpowers' }
      },
      {
        path: 'signin',
        name: 'SignIn',
        component: () => import('../pages/SignIn.vue'),
        meta: { noindex: true }
      },
      {
        path: 'signup', 
        name: 'SignUp',
        component: () => import('../pages/SignUp.vue'),
        meta: { noindex: true }
      },
      {
        path: 'about',
        name: 'About',
        component: () => import('../pages/About.vue'),
        meta: { seoKey: 'about' }
      },
      {
        path: 'comparison',
        name: 'Comparison',
        component: () => import('../pages/Comparison.vue'),
        meta: { seoKey: 'comparison' }
      },
      {
        path: 'pricing',
        name: 'Pricing', 
        component: () => import('../pages/Pricing.vue'),
        meta: { seoKey: 'pricing' }
      },
      {
        path: 'contact',
        name: 'Contact',
        component: () => import('../pages/Contact.vue'),
        meta: { seoKey: 'contact' }
      },
      {
        path: 'privacy',
        name: 'Privacy',
        component: () => import('../pages/Privacy.vue'),
        meta: { seoKey: 'privacy' }
      },
      {
        path: 'terms',
        name: 'Terms',
        component: () => import('../pages/Terms.vue'),
        meta: { seoKey: 'terms' }
      },
      {
        path: 'commerce',
        name: 'Commerce',
        component: () => import('../pages/Commerce.vue'),
        meta: { seoKey: 'commerce' }
      },
      {
        path: 'reset-password',
        name: 'ResetPassword',
        component: () => import('../pages/ResetPassword.vue'),
        meta: { noindex: true }
      },
      // 改版前的兩版首頁，保留可存取的網址供比對。
      // noindex 讓它們不輸出 canonical/hreflang，也不會被收進 sitemap，避免與新首頁互打
      {
        path: 'home-v1',
        name: 'HomeV1',
        component: () => import('../pages/HomeV1.vue'),
        meta: { seoKey: 'home1', noindex: true }
      },
      {
        path: 'home-v2',
        name: 'HomeV2',
        component: () => import('../pages/HomeV2.vue'),
        meta: { seoKey: 'home2', noindex: true }
      }
    ]
  },
  
  // 3. 404 處理
  //    伺服器端由 Firebase 的 404.html 處理（回真正的 404 狀態碼）；
  //    這條只負責 SPA 內部導航點到不存在的路徑時顯示畫面，不再靜悄悄跳回首頁
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../pages/NotFound.vue'),
    meta: { noindex: true }
  }
]

export default routes